import { render, staticRenderFns } from "./scheduler-room.vue?vue&type=template&id=2e01fc9d"
import script from "./scheduler-room.vue?vue&type=script&lang=ts"
export * from "./scheduler-room.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports